"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Filter array with limit
 *
 * @type {Array<T>}
 */
function filterLimit(src, fn, limit) {
    if (limit === void 0) { limit = 1; }
    if (!src || src.length === 0) {
        return [];
    }
    var results = [];
    var count = 0;
    src.every(function (item) {
        if (fn(item)) {
            results.push(item);
            count++;
            if (count === limit) {
                return false;
            }
        }
        return true;
    });
    return results;
}
exports.filterLimit = filterLimit;
/**
 * From distinct array
 *
 * @type {Array<T2>}
 */
function fromDistinct(src, fn, distinctFn) {
    if (!src || src.length === 0) {
        return [];
    }
    if (!distinctFn) {
        return src.reduce(function (acc, m) {
            var val = fn(m);
            return acc.indexOf(val) !== -1 ? acc : acc.concat([val]);
        }, []);
    }
    var results = [];
    for (var i = 0; i < src.length; ++i) {
        var m = src[i];
        if (!distinctFn(src.slice(0, i + 1), m)) {
            continue;
        }
        results.push(fn(m));
    }
    return results;
}
exports.fromDistinct = fromDistinct;
function splitArray(input, condition) {
    var tList = [];
    var fList = [];
    if (!input || input.length === 0) {
        return [tList, fList];
    }
    for (var _i = 0, input_1 = input; _i < input_1.length; _i++) {
        var item = input_1[_i];
        if (condition(item)) {
            tList.push(item);
        }
        else {
            fList.push(item);
        }
    }
    return [tList, fList];
}
exports.splitArray = splitArray;
//# sourceMappingURL=array.js.map